import { bool, node, number } from "prop-types";

import styled from "styled-components";

import FnrNumericIndicator from "UI/FnrNumericIndicator";

const SettingsOptionWrapper = ({ count, showCount, children }) => (
  <SDiv>
    {children}
    <FnrNumericIndicator inline count={count} show={showCount} />
  </SDiv>
);

SettingsOptionWrapper.propTypes = {
  count: number,
  showCount: bool,
  children: node,
};

const SDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 4px;
  white-space: nowrap;
`;

export default SettingsOptionWrapper;
